import React from 'react';
import './Loader.css';

interface LoaderProps {
    message?: string;
    size?: 'small' | 'medium' | 'large';
    fullScreen?: boolean;
}

const Loader: React.FC<LoaderProps> = ({
    message = 'Chargement...',
    size = 'medium',
    fullScreen = false
}) => {
    return (
        <div className={`loader-container ${fullScreen ? 'loader-fullscreen' : ''} loader-${size}`}>
            <div className="lamp-loader">
                <div className="lamp">
                    <div className="lamp-top"></div>
                    <div className="lamp-neck"></div>
                    <div className="lamp-base"></div>
                    <div className="lamp-glow"></div>
                </div>
            </div>
            {message && <p className="loader-message">{message}</p>}
        </div>
    );
};

export default Loader;
